import React from 'react';
import ItemRowMenu from '~/app/common/ItemRowMenu';
import useTranslation from '~/app/hooks/useTranslation';
import { Material } from '~/types';

export interface MaterialRowMenuProps {
  material: Material
  onEdit?: (material: Material) => void
  onRemove: (material: Material) => void
}

export type MaterialRowMenuComponent = React.FC<MaterialRowMenuProps>

const MaterialRowMenu: MaterialRowMenuComponent = ({ material, onEdit, onRemove }) => {
  const { t } = useTranslation('parts');

  return (
    <ItemRowMenu
      item={material}
      onEdit={onEdit}
      onRemove={onRemove}
      confirmationText={t('removeMaterialConfirm')}
    />
  );
};

export default MaterialRowMenu;
